import { isImmutable,Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const UINotificationActionRecord = Record({
  label: null,
  action: {},
  autoDismiss: true
});

// Custom to force action back to a plain object if it has been converted
// to immutable at any point
createFromJS.registerCallback("UINotificationActionRecord", any =>
  new UINotificationActionRecord(any).update("action", a => (isImmutable(a) ? a.toJS() : a))
);
